import {useEffect, useState} from "react";
import { ReactComponent as Arrow } from '../../assets/icons/arrow.svg';

import * as S from './styles'

const scrollToTop = () => window.scrollTo(0, 0);

export const ScrollTop = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            if (scrollY > 400) {
                setShow(true)
            } else {
                setShow(false)
            }
        };
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [])

    return <S.Button show={show} onClick={scrollToTop}><Arrow/></S.Button>
}